import React from "react";
import Loader from "react-loader-spinner";

const Loading = () => {
  return (
    <div className='main-table__loader'>
      <Loader type='Watch' color='#2959F8' height={40} width={40} />
    </div>
  );
};

export default Loading;
